// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JIrRSdon3XULqQrUAPZd {
    display: flex;
    gap: 32px;
}

.HW70mD90nv3C1gODIIS8 {
    display: flex;
    flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Confirmation/ConfirmationNoPayment/ConfirmationNoPayment.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".confirmationNoPaymentWrapper {\n    display: flex;\n    gap: 32px;\n}\n\n.leftColumn {\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationNoPaymentWrapper": `JIrRSdon3XULqQrUAPZd`,
	"leftColumn": `HW70mD90nv3C1gODIIS8`
};
export default ___CSS_LOADER_EXPORT___;
